// app/(auth)/login/page.tsx
"use client";

import { useState, useTransition } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { sendMagicLink, type LoginResult } from "./actions";

export default function LoginPage() {
  const [isPending, startTransition] = useTransition();
  const [resultat, setResultat] = useState<LoginResult | null>(null);

  function håndterSubmit(formData: FormData) {
    startTransition(async () => {
      const r = await sendMagicLink(formData);
      setResultat(r);
    });
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      {/* Venstre: form */}
      <div className="flex flex-col items-center justify-center px-6 py-12 lg:px-12">
        <div className="w-full max-w-sm flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2.5">
              <span className="flex size-8 items-center justify-center rounded-md bg-primary text-primary-foreground font-heading text-base font-semibold">
                o
              </span>
              <span className="font-heading text-lg font-semibold tracking-tight">
                omberamming
              </span>
            </div>
            <h1 className="font-heading text-3xl tracking-tight">Logg inn</h1>
            <p className="text-sm text-muted-foreground">
              Vi sender en magic link til e-posten din. Ingen passord å huske.
            </p>
          </div>

          <form action={håndterSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Label htmlFor="e_post">E-post</Label>
              <Input
                id="e_post"
                name="e_post"
                type="email"
                placeholder="navn@epost.no"
                required
                autoComplete="email"
                disabled={isPending}
              />
            </div>
            <Button type="submit" className="w-full" disabled={isPending}>
              {isPending ? "Sender…" : "Send magic link"}
            </Button>
            {resultat?.success && (
              <p className="text-sm text-primary">{resultat.melding}</p>
            )}
            {resultat && !resultat.success && (
              <p className="text-sm text-destructive">{resultat.feil}</p>
            )}
          </form>

          <p className="text-xs text-muted-foreground">
            Bare medlemmer på allowlisten kan logge inn. Ta kontakt med Finnolav for tilgang.
          </p>
        </div>
      </div>

      {/* Høyre: editorial-blokk, kun synlig på store skjermer */}
      <div className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-primary text-primary-foreground p-12">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] opacity-70">
            Verktøy for lagledere i breddefotball
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-heading text-4xl xl:text-5xl leading-[1.05] tracking-tight">
            Hold styr på omberammingen.
            <br />
            Bruk tiden på fotballen.
          </p>
          <p className="text-sm opacity-80 max-w-md">
            Sakshåndtering, kontaktregister, AI-assistanse og påminnelser — samlet for laglederen som
            koordinerer kamper i Akershus og rundt.
          </p>
        </div>
      </div>
    </div>
  );
}
